import React from 'react';

function IconRenderer({ icon: Icon, classes }) {
    return <Icon sx={classes} />;
}

export default IconRenderer;
